//
// Copyright (c) 2021 Astute Global, Inc.
//

import { LinkImageEditing, Matcher, Plugin } from "ckeditor5";
import AkLinkEditing from "./akLinkEditing";
import {
  ATTRIBUTE_CONTENT_MAPPING,
  ATTRIBUTE_LINK_TOPIC,
  contentMappingModelAttributeToViewAttributes,
  contentMappingViewElementToModelAttribute,
  downcastImageLinkDataAttributes,
  topicLinkModelAttributeToViewAttributes,
  topicLinkViewElementToModelAttribute,
  upcastImageLinkDataAttributes,
} from "./util";

export default class AkLinkImageEditing extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [LinkImageEditing, AkLinkEditing];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "AkLinkImageEditing";
  }

  // noinspection JSUnusedGlobalSymbols
  afterInit() {
    const editor = this.editor;
    this._setupSchema(editor);
    this._setupContentMappingConversion(editor);
    this._setupTopicLinkConversion(editor);
  }

  _setupContentMappingConversion(editor) {
    editor.conversion
      .for("downcast")
      .add(
        downcastImageLinkDataAttributes(
          ATTRIBUTE_CONTENT_MAPPING,
          contentMappingModelAttributeToViewAttributes,
        ),
      );
    editor.conversion.for("upcast").add(
      upcastImageLinkDataAttributes(
        editor,
        new Matcher({
          attributes: {
            "data-rdcontent": true,
          },
        }),
        ATTRIBUTE_CONTENT_MAPPING,
        contentMappingViewElementToModelAttribute,
      ),
    );
  }

  _setupSchema(editor) {
    editor.model.schema.extend("imageBlock", { allowAttributes: ATTRIBUTE_CONTENT_MAPPING });
    editor.model.schema.extend("imageBlock", { allowAttributes: ATTRIBUTE_LINK_TOPIC });
    editor.model.schema.extend("imageInline", { allowAttributes: ATTRIBUTE_CONTENT_MAPPING });
    editor.model.schema.extend("imageInline", { allowAttributes: ATTRIBUTE_LINK_TOPIC });
  }

  _setupTopicLinkConversion(editor) {
    editor.conversion
      .for("dataDowncast")
      .add(
        downcastImageLinkDataAttributes(ATTRIBUTE_LINK_TOPIC, (modelAttributeValue) =>
          topicLinkModelAttributeToViewAttributes(modelAttributeValue),
        ),
      );
    editor.conversion
      .for("editingDowncast")
      .add(
        downcastImageLinkDataAttributes(ATTRIBUTE_LINK_TOPIC, (modelAttributeValue) =>
          topicLinkModelAttributeToViewAttributes(modelAttributeValue),
        ),
      );
    editor.conversion.for("upcast").add(
      upcastImageLinkDataAttributes(
        editor,
        new Matcher({
          attributes: {
            "data-intent": true,
          },
        }),
        ATTRIBUTE_LINK_TOPIC,
        topicLinkViewElementToModelAttribute,
      ),
    );
  }
}
